module.exports = __webpack_public_path__ + "static/media/4.f05c86e4.jpeg";